import React, { ReactNode } from 'react';

import { isFeatureFlagsViaGql } from '../../utils/featureFlags/isFeatureFlagsViaGql';
import { LaunchDarklyProvider } from '../LaunchDarkly';
import { FeatureFlagsProvider } from './FeatureFlagsProvider';

interface FeatureFlagsRouterProps {
  children: ReactNode;
}

export const FeatureFlagsRouter: React.FC<FeatureFlagsRouterProps> = ({ children }) => {
  if (isFeatureFlagsViaGql()) {
    return <FeatureFlagsProvider>{children}</FeatureFlagsProvider>;
  }

  return <LaunchDarklyProvider>{children}</LaunchDarklyProvider>;
};
